import {
  TransactionAddonFormRule,
  TransactionAddonFormSchema,
} from "@factory/form/form.rule";
import "./form-transaction-addon-wrapper.scss";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { transactionAddonFormDefault } from "@factory/form/form.default";
import { zodResolver } from "@hookform/resolvers/zod";
import { forwardRef, useImperativeHandle } from "react";
import FormTransactionAddon from "../form-transaction-addon/form-transaction-addon";

export interface FormTransactionAddonWrapperProps {
  onSubmit: (data: TransactionAddonFormSchema) => void;
}
export interface FormTransactionAddonWrapperRef {
  triggerSubmit: () => void;
  triggerReset: () => void;
  getValues: () => TransactionAddonFormSchema;
}

export function FormTransactionAddonWrapper(
  props: FormTransactionAddonWrapperProps,
  ref: React.Ref<FormTransactionAddonWrapperRef>
) {
  const formMethod = useForm<TransactionAddonFormSchema>({
    defaultValues: transactionAddonFormDefault,
    resolver: zodResolver(TransactionAddonFormRule),
  });
  const { handleSubmit, reset } = formMethod;

  useImperativeHandle(ref, () => ({
    triggerSubmit: () => handleSubmit(submitHandler)(),
    triggerReset: () => reset(),
    getValues: () => formMethod.getValues(),
  }));

  const submitHandler: SubmitHandler<TransactionAddonFormSchema> = (data) => {
    props.onSubmit(data);
  };
  return (
    <div
      id="FormTransactionAddonWrapper"
      className="form-transaction-addon-wrapper"
    >
      <FormProvider {...formMethod}>
        <FormTransactionAddon />
      </FormProvider>
    </div>
  );
}

export default forwardRef(FormTransactionAddonWrapper);
